import * as React from 'react';
import { connect } from 'react-redux';
import { GlobalPrivateState, formatMessage } from 'src/api';
import { ConfigurationModel, LEFT_RIGHT, WITH_WITHOUT } from 'franke-trough-dependencies';
import { FormattedMessage } from 'react-intl';
import MESSAGES from './checkout.messages';

export interface  ApronBacksplashPartialCheckoutProps {
  checkout: GlobalPrivateState['checkout'];
  configuration: GlobalPrivateState['configuration'];
}

const getBacksplashPositionText = (position: LEFT_RIGHT[] | null): string => {
  let message = formatMessage(MESSAGES.apronBackSplashPositionBack);

  if (position && position.indexOf('left') > -1) {
    message = formatMessage(MESSAGES.apronBackSplashPositionLeft) + " + " + message;
  }
	if (position && position.indexOf('right') > -1) {
    message = message + " + " + formatMessage(MESSAGES.apronBackSplashPositionRight);
  }

  return message;
};

const getApronPositionText = (position: WITH_WITHOUT | LEFT_RIGHT | null): string => {
  let message = formatMessage(MESSAGES.apronBackSplashPositionFront);

  if (position === "without") {
    message = formatMessage(MESSAGES.apronBackSplashPositionLeft) + " + " + message + " + " + formatMessage(MESSAGES.apronBackSplashPositionRight);
  } else if (position === "left") {
    message = message + " + " + formatMessage(MESSAGES.apronBackSplashPositionRight);
  } else if (position === "right") {
    message = formatMessage(MESSAGES.apronBackSplashPositionLeft) + " + " + message;
  }

  return message;
};

export class ApronBacksplashPartialCheckout extends React.Component<ApronBacksplashPartialCheckoutProps, any> {
  public render() {
    const apronBackSplash = this.configuration && this.configuration.apronBackSplash;
    const washBasinDimension = this.configuration && this.configuration.washBasinDimension;
    return apronBackSplash && washBasinDimension && (
      <div className="apron-backsplash-partial-line">
        <span className="configuration-name">
          <FormattedMessage {...MESSAGES.apronBackSplashHeadline} />
        </span>
        <ul>
          {apronBackSplash.apron === 'with' && (
            <li>
              <FormattedMessage {...MESSAGES.apronBackSplashApron} values={{
                position: getApronPositionText(washBasinDimension.typeOfInstallation),
                height: apronBackSplash.apronHeight
              }} />
            </li>
          )}
          {apronBackSplash.surgeEdgeOrBackSplash !== 'without' && (
            <li>
              {apronBackSplash.surgeEdgeOrBackSplash === 'withBackSplash' && (
                <FormattedMessage {...MESSAGES.apronBackSplash} values={{
                  position: getBacksplashPositionText(apronBackSplash.positionOfEdgeOrBacksplash),
                  height: apronBackSplash.backsplashHeight,
                }}/>
              )}
              {apronBackSplash.surgeEdgeOrBackSplash === 'withSurgeEdge' && (
                <FormattedMessage {...MESSAGES.apronBackSplashSurgeEdge}values={{
                  position: getBacksplashPositionText(apronBackSplash.positionOfEdgeOrBacksplash),
                }}/>
              )}
              
            </li>
          )}
        </ul>
      </div>
    ) || null;
  }

  private get configuration(): ConfigurationModel | undefined {
    const { configuration } = this.props;
    return configuration && configuration.result;
  }
}

export const ApronBacksplashPartialCheckoutComponent = connect((state: GlobalPrivateState) => ({
  configuration: state.configuration,
  checkout: state.checkout,
}))(ApronBacksplashPartialCheckout);

export default ApronBacksplashPartialCheckoutComponent;